export const HEIGHT = 64;
export const NAME = 'ANNOUNCEMENT' as const;
